// Overlay.js
import React, { useEffect, useState } from "react";
import "./AddLocationOverlay.css"; // You can customize this
import Loading from "../preloader/Loading";
import { Button } from "@windmill/react-ui";

import { Scrollbars } from "react-custom-scrollbars-2";
import { Textarea, Select } from "@windmill/react-ui";
import { useForm } from "react-hook-form";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import { SidebarContext } from "../../context/SidebarContext";
import { useQueryClient } from "@tanstack/react-query";
import { GoAlert } from "react-icons/go";
import { useTranslation } from "react-i18next";

import Title from "../form/Title";
import Error from "../form/Error";
import LabelArea from "../form/LabelArea";
import InputArea from "../form/InputArea";
import DrawerButton from "../form/DrawerButton";
import validations from "../../utils/validations";

import { getError, descriptionCharLimitClass } from "../../utils/helpers";
import { localStorageToken, localStorageUser,authStorage } from "../../utils/variables";

import { useStoreLocationMasterData } from "../../hooks/storeLocation";

const defaultValues = {
  storeLocationCode: "",
  name: "",
  description: "",
  address1: "",
  address2: "",
  city: "",
  province: {
    provinceId: 1,
  },
  deleted: false,
  country: {
    countryId: 0,
  },
  zipcode: "",
  latitude: "0",
  longitude: "0",
  storeLocationStatus: {
    locationStatusId: 1,
  },
  primaryDomainUrl: "",
};

const AddLocationOverlay = ({ isOpen, onClose, onSaveSuccess }) => {
  const queryClient = useQueryClient();

  const {
    register,
    formState: { errors },
    handleSubmit,
    watch,
    reset,
  } = useForm({
    defaultValues,
  });

  const { t } = useTranslation();

  const storeLocationMasterData = useStoreLocationMasterData();

  const loggedInUser = JSON.parse(authStorage.getItem(localStorageUser));

  const [countriesObject, setCountriesObject] = useState({});

  const [provincesObject, setProvincesObject] = useState({});

  const [renderedToast, setRenderedToast] = useState(null);

  useEffect(() => {
    if (storeLocationMasterData.data?.countries?.length > 0) {
      const object = {};
      const subObject = {};

      storeLocationMasterData.data?.countries.map((country) => {
        object[country.countryId] = country;
        country.provinces?.map(
          (province) => (subObject[province.provinceId] = province)
        );
      });

      setCountriesObject(object);
      setProvincesObject(subObject);
    }
  }, [storeLocationMasterData.data]);

  const createPayload = (object) => {
    return {
      storeLocation: {
        store: {
          storeId: loggedInUser?.storeId,
        },
        ...object,

        formattedAddress: `${object.address1}, ${object.address2}, ${
          object.city
        }, ${provincesObject[object.province.provinceId]?.provinceName}, ${
          countriesObject[object.country.countryId]?.countryName
        }, ${object.zipcode}`,
      },
    };
  };

  // Mutations

  const getLocationCoords = useMutation({
    mutationFn: async (values) => {
      const payload = createPayload(values);
      console.log("Payload for geocoding:", payload);
      const string = `${payload.storeLocation?.address1} + ${
        payload.storeLocation?.address2
      }, + ${payload.storeLocation?.city}, + ${
        provincesObject[payload?.storeLocation?.province?.provinceId]
          ?.provinceCode
      }`;

      return await axios.get(`${process.env.REACT_APP_GOOGLE_GEOCODE_API}`, {
        params: {
          address: string,
          key: encodeURIComponent(process.env.REACT_APP_GOOGLE_API_KEY),
        },
      });
    },
    onMutate: () => {
      // const toastId = toast.loading("Fetching location coordinates", {
      //   position: "top-center",
      // });
      // setRenderedToast(toastId);
    },
    onSuccess: (data, variables, context) => {
      if (data.data?.results?.length > 0) {
        // toast.update(renderedToast, {
        //   render: "Creating store location",
        //   type: "default",
        //   isLoading: true,
        //   autoClose: 2000,
        // });

        const newObject = {
          ...variables,
          latitude: data.data.results[0]?.geometry?.location?.lat,
          longitude: data.data.results[0]?.geometry?.location?.lng,
        };

        // Call add or edit according to presence of id

        addStoreLocation.mutate(newObject);
      } else throw data;
    },
    onError: (error, variables, context) => {
      toast.update(renderedToast, {
        render: "Error in confirming your location. Please check the address.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
        hideProgressBar: false,
      });
    },
  });

  const addStoreLocation = useMutation({
    mutationFn: async (values) => {
      const token = authStorage.getItem(localStorageToken);

      const payload = createPayload(values);
      console.log("Token:", token);
      console.log("Payload:", payload);
      return await axios.post(
        `${process.env.REACT_APP_STORE_LOCATION_API}/stores/${loggedInUser?.storeId}/locations`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    },
    onMutate: () => {
      const toastId = toast.loading("Creating store location", {
        position: "top-center",
        autoClose: 2000,
      });
      setRenderedToast(toastId); // Ensure toast ID is set
    },
    onSuccess: (response) => {
      const code = response?.data?.code;
      const message =
        response?.data?.message ||
        response?.data?.errorMessage;
     
        

      if (code === 200) {
        if (renderedToast) {
          toast.update(renderedToast, {
            render: message,
            type: "success",
            isLoading: false,
            autoClose: 3000,
            hideProgressBar: false,
          });
        } else {
          toast.success(message);
        }
        queryClient.invalidateQueries({ queryKey: ["storeLocations"] });
        localStorage.setItem("store_location_exists", "true");
        if (onClose) onClose();
      } else {
        const failMessage = message || "Failed to create store location";
        if (renderedToast) {
          toast.update(renderedToast, {
            render: failMessage,
            type: "error",
            isLoading: false,
            autoClose: 4000,
            hideProgressBar: false,
          });
        } else {
          toast.error(failMessage);
        }
      }
    },
    onError: (error) => {
      toast.update(renderedToast, {
        render: getError(error),
        type: "error",
        isLoading: false,
        autoClose: 3000,
        hideProgressBar: false,
      });
    },
  });

  useEffect(() => {
    const locationExists = localStorage.getItem("store_location_exists");
    console.log("Location exists (raw):", locationExists);

    if (locationExists === "true" || locationExists === null || locationExists === undefined) {
        console.log("Location exists or is not set, closing overlay.");
        onClose(); // Close overlay if location exists or is not set
    } else {
        console.log("Location does not exist, keeping overlay open.");
    }
  }, []);

  if (!isOpen) return null;
  return (
    <div className="overlay">
      <div className="overlay-content">
        <div className="w-full p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 sticky top-0 z-10">
          <Title
            title={t("add-location-title")}
            description={t("add-location-description")}
          />
        </div>
        <form
          onSubmit={handleSubmit((values) =>
            getLocationCoords.mutate(values)
          )}
          className="h-[90%] overflow-y-auto"
        >
          <div className="px-6 pt-8 flex-grow w-full h-full max-h-full pb-8 md:pb-8 lg:pb-8 xl:pb-8">
            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label={t("location-name-label")} required />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  label={t("location-name-label")}
                  name="name"
                  type="text"
                  placeholder={t("location-name-placeholder")}
                  required
                  validations={validations.locationName}
                />
                <Error errorName={errors.name} />
              </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label={t("location-status-label")} required />
              <div className="col-span-8 sm:col-span-4">
                <Select
                  className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-white border-transparent focus:bg-white"
                  name="locationStatusId"
                  {...register("storeLocationStatus.locationStatusId", {
                    required: {
                      value: true,
                      message: t("location-status-required-error-message"),
                    },
                  })}
                >
                  {storeLocationMasterData.data?.statuses?.map((status) => (
                    <option value={status.locationStatusId}>
                      {status.label}
                    </option>
                  ))}
                </Select>
                <Error
                  errorName={errors.storeLocationStatus?.locationStatusId}
                />
              </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label={t("location-description-label")} />
              <div className="col-span-8 sm:col-span-4">
                <Textarea
                  className="border text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                  {...register("description", validations.description)}
                  name="description"
                  placeholder={t("location-description-placeholder")}
                  rows="4"
                  spellCheck="false"
                />
                {errors.description ? (
                  <Error errorName={errors.description} />
                ) : (
                  <span className="text-sm mt-2 flex justify-between items-center text-gray-500">
                    <span className="flex items-center">
                      <GoAlert />{" "}
                      <span className="ml-2">
                        {t("description-char-limit")}
                      </span>
                    </span>
                    <span
                      className={descriptionCharLimitClass(
                        watch("description")
                      )}
                    >
                      {watch("description")?.length}
                    </span>
                  </span>
                )}
              </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label={t("location-url-label")} />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  label={t("location-url-label")}
                  name="primaryDomainUrl"
                  type="text"
                  placeholder={t("location-url-placeholder")}
                  validations={validations.url}
                />
                <Error errorName={errors.primaryDomainUrl} />
              </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label={t("location-country-label")} required />
              <div className="col-span-8 sm:col-span-4">
                <Select
                  className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-white border-transparent focus:bg-white"
                  name="countryId"
                  {...register("country.countryId", {
                    required: t("location-country-required-error-message"),
                  })}
                >
                  <option value="" defaultValue hidden>
                    {t("location-country-placeholder")}
                  </option>
                  {storeLocationMasterData.data?.countries?.map((country) => (
                    <option value={country.countryId}>
                      {country.countryName}
                    </option>
                  ))}
                </Select>
                <Error errorName={errors.country?.countryId} />
              </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label={t("location-state-label")} required />
              <div className="col-span-8 sm:col-span-4">
                <Select
                  className="border h-12 text-sm focus:outline-none block w-full bg-gray-100 dark:bg-white border-transparent focus:bg-white"
                  name="provinceId"
                  {...register("province.provinceId", {
                    required: t("location-state-error-message"),
                  })}
                  disabled={!watch("country.countryId")}
                >
                  <option value="" defaultValue hidden>
                    {t("location-state-placeholder")}
                  </option>

                  {countriesObject[
                    watch("country.countryId")
                  ]?.provinces?.map((province) => (
                    <option value={province.provinceId}>
                      {province.provinceName}
                    </option>
                  ))}
                </Select>
                <Error errorName={errors.province?.provinceId} />
              </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label={t("address-line-1-label")} required />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  label={t("address-line-1-label")}
                  name="address1"
                  type="text"
                  placeholder={t("address-line-1-placeholder")}
                  required
                />
                <Error errorName={errors.address1} />
              </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label={t("address-line-2-label")} />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  label={t("address-line-2-label")}
                  name="address2"
                  type="text"
                  placeholder={t("address-line-2-placeholder")}
                />
                <Error errorName={errors.address2} />
              </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label="City" required />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  label={t("location-city-label")}
                  name="city"
                  type="text"
                  placeholder={t("location-city-placeholder")}
                  required
                />
                <Error errorName={errors.city} />
              </div>
            </div>

            <div className="grid grid-cols-6 gap-3 md:gap-5 xl:gap-6 lg:gap-6 mb-6">
              <LabelArea label={t("location-zip-code-label")} required />
              <div className="col-span-8 sm:col-span-4">
                <InputArea
                  register={register}
                  label={t("location-zip-code-label")}
                  name="zipcode"
                  type="text"
                  placeholder={t("location-zip-code-placeholder")}
                  required
                  validations={validations.zipCode}
                />
                <Error errorName={errors.zipcode} />
              </div>
            </div>
          </div>
          <div className="">
            <div className="bottom-0 w-full right-0 py-4 lg:py-8 px-6 grid gap-4 lg:gap-6 xl:gap-6 md:flex xl:flex bg-gray-50 border-t border-gray-100 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
              <div className="flex-grow-0 md:flex-grow lg:flex-grow xl:flex-grow">
                <Button
                  className="h-12 bg-white w-full text-red-500 hover:bg-red-50 hover:border-red-100 hover:text-red-600 dark:bg-gray-700 dark:border-gray-700 dark:text-gray-500 dark:hover:bg-gray-800 dark:hover:text-red-700"
                  layout="outline"
                  onClick={() => reset({ ...defaultValues, country: { countryId: "" } })}
                >
                  Reset
                </Button>
              </div>
              <div className="flex-grow-0 md:flex-grow lg:flex-grow xl:flex-grow">
                <Button
                  type="submit"
                  className="w-full h-12"
                >

                  <span>Add Location</span>

                </Button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddLocationOverlay;
